import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/modal-confirmation/conductor-save.svg'


const _hoisted_1 = { class: "card-no-shadow bg-white rounded-lg" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mb-5 mx-3 mt-3" }
const _hoisted_4 = { class: "text-2xl font-bold" }
const _hoisted_5 = { class: "pb-5" }
const _hoisted_6 = {
  key: 0,
  style: {"height":"50vh","overflow-x":"auto"},
  class: "px-1"
}
const _hoisted_7 = {
  key: 1,
  style: {"height":"50vh","overflow-x":"auto"},
  class: "px-2 pt-1"
}
const _hoisted_8 = {
  key: 0,
  class: "timeline-title text-sm font-normal text-grey"
}
const _hoisted_9 = {
  key: 1,
  class: "timeline-desc text-sm font-normal text-grey"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-center my-auto\"><div class=\"flex flex-col items-center py-5\"><div><img class=\"w-1/3 lg:w-2/3 mb-5 mx-auto\" src=\"" + _imports_0 + "\"></div><div class=\"text-lg font-bold text-center\"> Belum ada Trayek Terdaftar </div><div class=\"text-sm font-normal text-center mb-5 w-full lg:w-2/3\"> Masih belum ada trayek yang terdaftar pada trayek ini. Tambah trayek pertamamu dengan klik Tambah trayek di bawah </div></div></div>", 1)
const _hoisted_12 = [
  _hoisted_11
]

import {
  ref,
  computed,
  watch,
  reactive
} from 'vue'
import { useStore } from 'vuex'
import { isEmpty } from 'lodash'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import HjpTabView from '@/views/components/tab/HjpTabView.vue'
import TimelineLogger from '@/views/components/timeline/Logger.vue'
import type { TSlotDefaultParam } from '@/views/components/timeline/Logger.vue'
import ListVirtualScroll from '@/views/components/list/VirtualScroll.vue'
import type { TSlotDefaultParamVS } from '@/views/components/list/VirtualScroll.vue'
import moment from 'moment'
import { ILogConductor } from '@/utils/interfaces/iConductor'
import { IRoster } from '@/utils/interfaces/iRoster'


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoConductor',
  setup(__props) {

const module = 'plotting'

const store = useStore()
const selectedConductor = computed(() => store.getters[`${module}/selectedConductor`])
const selectedTab = ref(0)
const tabHeader = ref([
  { title: 'Jadwal Aktif', value: 0 },
  { title: 'Log Kondektur', value: 1 }
])
const tabsChange = (val: any) => {
  selectedTab.value = val
}
const logConductorAttr = reactive({
  endpoint: '/management/v1/ActivityLog/CondecturLogs',
  filters: [['username', '=', selectedConductor.value.username]]
})

const scheduleActiveAttr = reactive({
  endpoint: '/roster/v1/Roster',
  filters: [['condecturUsername', '=', selectedConductor.value.username]]
})

const refScheduleActiveVs = ref<InstanceType<typeof ListVirtualScroll>>()

watch(selectedConductor, (newVal, oldVal) => {
  if (newVal && newVal !== oldVal) {
    selectedTab.value = 0
    logConductorAttr.filters = [['username', '=', selectedConductor.value.username]]
    scheduleActiveAttr.filters = [['condecturUsername', '=', selectedConductor.value.username]]
    // eslint-disable-next-line no-unused-expressions
    refScheduleActiveVs.value?.reloadData()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isEmpty)(_unref(selectedConductor)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(selectedConductor).label), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(HjpTabView, {
              currActive: selectedTab.value,
              tabHeader: tabHeader.value,
              onTabsChange: tabsChange,
              class: "wrap-tab-view-condectur"
            }, null, 8, ["currActive", "tabHeader"]),
            (selectedTab.value === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(ListVirtualScroll, _mergeProps(scheduleActiveAttr, {
                    ref_key: "refScheduleActiveVs",
                    ref: refScheduleActiveVs
                  }), {
                    default: _withCtx(({ items }: TSlotDefaultParamVS<IRoster>) => [
                      _createVNode(_unref(DataTable), { value: items }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Column), {
                            field: "RegNumber",
                            header: "NOPOL",
                            style: {"width":"33%"}
                          }),
                          _createVNode(_unref(Column), {
                            field: "RosterDate",
                            header: "TANGGAL",
                            style: {"width":"34%"}
                          }, {
                            body: _withCtx(({ data, field }) => [
                              _createTextVNode(_toDisplayString(_unref(moment)(data[field]).format('DD MMM YYYY')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(Column), {
                            field: "DepartureTime",
                            header: "JAM",
                            style: {"width":"33%"}
                          })
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ]),
                    _: 1
                  }, 16)
                ]))
              : (selectedTab.value === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(ListVirtualScroll, _normalizeProps(_guardReactiveProps(logConductorAttr)), {
                      default: _withCtx(({ items }) => [
                        _createVNode(TimelineLogger, { items: items }, {
                          default: _withCtx(({ data }: TSlotDefaultParam<ILogConductor>) => [
                            data
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(moment)(data.CreatedAt).format('DD MMMM YYYY')), 1))
                              : _createCommentVNode("", true),
                            data
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(data.UpdatedString), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["items"])
                      ]),
                      _: 1
                    }, 16)
                  ]))
                : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
  ]))
}
}

})